import moment, { Moment } from 'moment';
import FeatureFlags from '../FeatureFlags';
import { CLIENT_BOOKING_OPT_IN_AUTO_CHECKOUT_TEST_KEY } from '../../components/consumer/booking/constants';
import { ClientPreferredCheckoutType } from '../../api/Providers/Appointments';
import { ssFetchJSON } from '../ssFetch';

const CLIENT_PREFERRED_CHECKOUT_TYPE_DEFAULT = ClientPreferredCheckoutType.Manual;

const fetchPreferredCheckoutMethod = async (
  providerId: number,
): Promise<ClientPreferredCheckoutType> => {
  try {
    const { preferred_checkout_type: value } = await ssFetchJSON<{
      preferred_checkout_type: ClientPreferredCheckoutType
    }>(`/api/v2/providers/${providerId}/client/preferred-checkout-type`);

    return value;
  } catch (error) {
    return CLIENT_PREFERRED_CHECKOUT_TYPE_DEFAULT;
  }
};

const calculateCheckoutPreference = async (
  { providerId, startMoment }: { providerId: number, startMoment: Moment },
): Promise<ClientPreferredCheckoutType> => {
  const daysInFuture = 14;
  const thresholdMoment = moment().endOf('day').add(daysInFuture, 'day');

  const autoCheckoutAssignment = startMoment.isBefore(thresholdMoment)
    ? await FeatureFlags.isEnabled(CLIENT_BOOKING_OPT_IN_AUTO_CHECKOUT_TEST_KEY)
    : null;
  return autoCheckoutAssignment
    ? ClientPreferredCheckoutType.Auto
    : fetchPreferredCheckoutMethod(providerId);
};

export default {
  fetchPreferredCheckoutMethod,
  calculateCheckoutPreference,
};
